/**
 * API client for the operator's own Online switch.
 *
 * Its own file for the reason `lib/callDivert.ts` gives: this is a switch thrown
 * from the call log on the way out of the door, not a settings form.
 */
import { api } from "./api";

export interface CallAvailability {
  /** Would an incoming call ring this person at all? */
  online: boolean;
  /** ISO instant Offline lapses, or "" for none, or while Online. */
  until: string;
  /** Nobody else would ring, so a call goes to voicemail or forwarding. */
  alone: boolean;
  /** The line answers calls at all. Without it the switch has nothing to do. */
  inboundReady: boolean;
}

export function getCallAvailability(): Promise<CallAvailability> {
  return api.get("/admin/crm/calls/availability");
}

export function setCallAvailability(online: boolean, until: string | null): Promise<CallAvailability> {
  return api.put("/admin/crm/calls/availability", { online, until });
}
